import React from 'react' // eslint-disable-line no-unused-vars
import '../../ui-elements/Modals'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import '../../css/ui-elements/modals.css'
import CountryAwareComponent from '../CountryAwareComponent'
import { validateField } from '../../pages/functions'
import { connect } from 'react-redux'
import { addNotification as notify } from 'reapop'
import StaticConfig from '../StaticConfig'
import { api } from '../index.api'

class ContactInformation extends CountryAwareComponent {
  constructor (props) {
    super(props)
    this.componentName = 'ContactInformation'
    this._validate = this._validate.bind(this)
    this.fields = {
      suggestion: {
        name: 'suggestion',
        value: '',
        rules: {
          title: this.props.pageContent.content.websiteFeedbackQuestion,
          required: false
        }
      },
      mailFrom: {
        name: 'emailTo',
        value: '',
        rules: {
          title: this.props.pageContent.content.responseEmail,
          required: false
        }
      },
      emailTo: {
        name: 'emailTo',
        value: 'medicalquestions@abbvie.com',
        rules: {
          title: 'Send to',
          required: false
        }
      }

    }

    this.state = {

      fields: this.fields

    }

    this.contactInformationRequest = {}
  }

  componentDidMount () {
    //  this.getBlockComponent("contactusLink");
    this.getBlockComponent('phone')
  }

  _validate (e, field) {
    var fields = validateField(e, field, this.state.fields)

    this.setState({ fields })

    return false
  }

  _submit = () => {
    var info = this._constructContactInformationRequest()
    this.props.toggle()
    this._callContactAPI(info)
  }

  _callContactAPI = info => {
    const languageContent = this.props.pageContent.content
    const contactInformation = {
      mailFrom: info.mailFrom,
      mailto: info.mailto,
      suggestion: info.suggestion
    }
    api.sendMail(contactInformation,
      this._sendMailSuccessHandler.bind(this, languageContent),
      this._sendMailErrorHandler.bind(this, languageContent)
    )
  }

  _sendMailSuccessHandler = (languageContent, res) => {
    if (res.status === 200) {
      this._showNotification(languageContent.success, languageContent.contactInfoMailSentMessage, 'success')
    } else {
      this._showNotification(languageContent.error, languageContent.errorSendingMail, 'error')
    }

    return res
  }

  _sendMailErrorHandler = (languageContent, error) => {
    this._showNotification(languageContent.error, languageContent.serverError, 'error')
  }

  _constructContactInformationRequest = () => {
    this.contactInformationRequest.emailTo = this.state.fields.emailTo.value
    this.contactInformationRequest.mailFrom = this.state.fields.mailFrom.value
    this.contactInformationRequest.suggestion = this.state.fields.suggestion.value

    return this.contactInformationRequest
  }

  _showNotification = (title, message, status) => {
    const { notify } = this.props
    notify({
      title,
      message,
      status,
      position: 'tr',
      dismissible: true,
      dismissAfter: 3000
    })
  }

  render () {
    const languageContent = this.props.pageContent.content

    return (
      <div>
        <Modal
          isOpen
          toggle={this.props.toggle}
          wrapClassName='modal-primary'
          size='default'
        >
          <ModalHeader toggle={this.props.toggle}>{languageContent.page.HOME.contactInfo}</ModalHeader>
          <ModalBody>
            <form onSubmit={e => {
              e.preventDefault()
              this._submit()
            }}
            >
              <p><i className='sli-globe m-r-5' /> <label> {StaticConfig.Context.Country.name} </label></p>
              <p><i className='sli-phone m-r-5' /> <label id='phone'> {languageContent.page.HOME.phone}: {StaticConfig.Context.ComponentConfig.phone} </label></p>
            </form>
          </ModalBody>
        </Modal>

      </div>)
  }
}

function mapStateToProps (state) {
  return {
    fields: state.fields,
    pageContent: state.pageContent
  }
}

export default connect(mapStateToProps, { notify })(ContactInformation)



// WEBPACK FOOTER //
// ./src/mi-app/modals/ContactInformation.js